//import { apiUrl as api_url } from "../utils/helpers/enviroment.helpers";
import { fetchWithCredentials, handleErrorsStatus } from "./httpService";

const api_path = "CentrosRecreativos/";

export const getCentrosRecreativos = async () => {
  try {
    const respuesta = await fetchWithCredentials(
      window.__CONFIG__.apiPrincipal + api_path,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return await handleErrorsStatus(respuesta);
    // return [
    //   {id:1, descripcion:"CLUB DE PESCA BARADERO"},
    //   {id:2, descripcion:"CRI CAÑUELAS"},
    //   {id:3, descripcion:"CRI ESTEBAN ECHEVERRIA"},
    //   {id:4, descripcion:"CRI FLORENCIO VARELA"},
    //   {id:5, descripcion:"CRI JOSE C. PAZ"},
    //   {id:6, descripcion:"CRI MORENO"},
    //   {id:7, descripcion:"CRI ZARATE"}
    // ]
  } catch (err) {
    console.error("Error", err);
    throw new Error("Ocurrió un error al buscar los centros recreativos.");
  }
};